import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from 'common/BaseComponent'
import Input from 'common/Input';
import theme from './PasswordPopup.scss';
import {ValidationResult, validate, required, allAreEqual, generateStrategyResult, focusFirstError} from 'validation'
import ErrorBox from 'common/ErrorBox';
import conf from 'configuration.json'
import Popup from 'common/Popup';
import {getMessage as msg} from 'MessageBundle'
import validator from 'validator';

export default class PasswordPopup extends BaseComponent{

    constructor (props) {
        super(props);

        this.validation = this.getValidation();
        this.state = this.getInitialState();

        this.elementOrder = {
            oldPassword : "oldPassword",
            newPassword: "newPassword",
            newPasswordConfirmation: "newPasswordConfirmation"
        };
    }

    getInitialState = () => {
        return {
            oldPassword: "",
            newPassword: "",
            newPasswordConfirmation: "",
            errorMessages: {}
        };
    };

    reset() {
        this.setState(this.getInitialState());
    }

    close() {
        this.reset();
        this.props.onClose();
    }

    getValidation() {
        const passwordFormat = ([password]) => {
            const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[_!()\[\]{}?$%&/=*+~,.;:<>-])[-A-Za-z\d$!%+=-~,.;:<>_*?&\[\]{}()/]{8,}$/;
            const errors = [];
            if (!validator.matches(password, passwordPattern) || validator.matches(password, this.props.accountName)) {
                errors.push(msg("passwordPopup.passwordInvalidError"));
            }
            return generateStrategyResult(errors);
        };

        return {
            common: [
                {
                    properties: ["state.oldPassword"],
                    individualNames: ["oldPassword"],
                    strategies: [
                        required(msg("passwordPopup.passwordOldError"))
                    ]
                },
                {
                    properties: ["state.newPassword", "state.newPasswordConfirmation"],
                    individualNames: ["newPassword", "newPasswordConfirmation"],
                    strategies: [
                        allAreEqual(msg("passwordPopup.passwordsNotEqualError"))
                    ]
                },
                {
                    properties: ["state.newPassword"],
                    individualNames: ["newPassword"],
                    strategies: [
                        required(msg("passwordPopup.passwordInvalidError")),
                        passwordFormat
                    ]
                }
            ]
        }
    }

    changePassword() {
        const validationResult = validate(this, this.validation, ["common"]);
        if (validationResult.isEmpty()) {
            this.setState({
                errorMessages: {}
            });
            this.request('post', conf.rest.changePasswordEndpoint).params({old: this.state.oldPassword, renewed: this.state.newPassword}).send(() => {
                this.reset();
                this.props.onClose();
            }, (error, result) => {
                let errorText;
                let invalidComponent;
                if (result && result.statusCode === 422) {
                    errorText = msg("passwordPopup.passwordOldError");
                    invalidComponent = ["oldPassword"];
                } else if (result && result.status === 403) {
                    errorText = msg('passwordPopup.intrusionLocked');
                    invalidComponent = [];
                } else {
                    errorText = msg("common.technicalError");
                    invalidComponent = [];
                }
                const validationResult = new ValidationResult(this.state.errorMessages);
                validationResult.setGroup("manual", {[invalidComponent]: [errorText]});
                this.showErrors(validationResult);
            });
        } else {
            this.showErrors(validationResult);
        }
    }

    showErrors = (validationResult) => {
        let newErrorMessages = validationResult.getErrorMessages();
        this.setState({
            errorMessages: newErrorMessages
        });
        focusFirstError(this.elementOrder, newErrorMessages);
    };

    resetPassword() {
        this.request('post', conf.rest.resetPasswordEndpoint).send(() => {
            this.props.onClose();
        }, () => {
            const validationResult = new ValidationResult(this.state.errorMessages);
            validationResult.setError("manual", msg("common.technicalError"));
            this.setState({
                errorMessages: validationResult.getErrorMessages()
            });
        });
    }

    render () {
        return (
            <Popup visible={this.props.visible}>
                <div className={theme.popupContent}>
                    <h2>{msg("passwordPopup.header")}</h2>
                    <div>
                        <ErrorBox groups={["common", "manual"]} errorMessages={this.state.errorMessages}/>
                        <div className={theme.clear}>
                            <div className={theme.coll}>
                                <h3>{msg("passwordPopup.fieldsHeader")}</h3>

                                <Input type="password" id="oldPassword" name="oldPassword" onChange={this.handleChange("oldPassword")} required className={theme.row}
                                    label={msg("passwordPopup.oldPassword")} errorMessages={this.state.errorMessages} value={this.state.oldPassword}/>

                                <Input type="password" id="newPassword" name="newPassword" onChange={this.handleChange("newPassword")} required className={theme.row}
                                    label={msg("passwordPopup.newPassword")} errorMessages={this.state.errorMessages} value={this.state.newPassword}/>

                                <Input type="password" id="newPasswordConfirmation"  name="newPasswordConfirmation" onChange={this.handleChange("newPasswordConfirmation")}
                                    required className={theme.row} label={msg("passwordPopup.newPasswordConfirmation")} errorMessages={this.state.errorMessages}
                                    value={this.state.newPasswordConfirmation}/>
                            </div>
                            <div className={theme.colr}>
                                <h3>{msg("passwordPopup.constraintsHeader")}</h3>
                                <h4>{msg("passwordPopup.password")}</h4>
                                <ul>
                                    <li>{msg("passwordPopup.eightCharConstraint")}</li>
                                    <li>{msg("passwordPopup.userConstraint")}</li>
                                    <li>{msg("passwordPopup.dataConstraint")}</li>
                                </ul>
                                <h4>{msg("passwordPopup.symbolsList")}</h4>
                                <ul>
                                    <li>{msg("passwordPopup.smallLetter")}</li>
                                    <li>{msg("passwordPopup.bigLetter")}</li>
                                    <li>{msg("passwordPopup.digits")}</li>
                                    <li>{msg("passwordPopup.specialSymbols")}</li>
                                </ul>
                            </div>
                        </div>
                        <div className={theme.btnGroup + ' ' + theme.clear}>
                            <div className={theme.coll}>
                                <div className={theme.btnGroupMini}>
                                    <span><span>*</span>{msg("passwordPopup.requiredFields")}</span>
                                    <button id="resetForm-btn" onClick={() => this.reset()}>{msg("passwordPopup.resetButton")}</button>
                                    <button id="resetPassword-btn" onClick={() => this.resetPassword()} title={msg("passwordPopup.sendNewPasswordButtonTooltip")}>{msg("passwordPopup.sendNewPasswordButton")}</button>
                                </div>
                            </div>
                            <div className={theme.colr}>
                                <button id="close-btn" onClick={() => this.close()}>{msg("passwordPopup.closeButton")}</button>
                                <button id="savePassword-btn" title={msg("passwordPopup.confirmationButtonTooltip")} onClick={() => this.changePassword()} className={theme.accent}
                                    disabled={!(this.state.oldPassword && this.state.newPassword && this.state.newPasswordConfirmation)}>
                                    {msg("passwordPopup.confirmationButton")}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </Popup>
        );
    }
}

PasswordPopup.propTypes = {

    /**
     * Function, set popup invisible
     */
    onClose: PropTypes.func.isRequired,

    /**
     * Boolean flag. Used for show popup.
     */
    visible: PropTypes.bool.isRequired
};


// WEBPACK FOOTER //
// ./src/dialogs/VPRekla/Start/PasswordPopup/index.js